import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { rootRouteRef, builderRouteRef, gesBuilderRouteRef } from './routes';

export const topologyViewerPlugin = createPlugin({
  id: 'topology-viewer',
  routes: {
    root: rootRouteRef,
    builder: builderRouteRef,
    gesBuilder: gesBuilderRouteRef,
  },
});

export const TopologyViewerPage = topologyViewerPlugin.provide(
  createRoutableExtension({
    name: 'TopologyViewerPage',
    mountPoint: rootRouteRef,
    component: () =>
      import('./components/TopologyViewerPage').then(
        m => m.TopologyViewerPage,
      ),
  }),
);

export const TopologyBuilderPage = topologyViewerPlugin.provide(
  createRoutableExtension({
    name: 'TopologyBuilderPage',
    mountPoint: builderRouteRef,
    component: () =>
      import('./components/TopologyBuilderPage').then(
        m => m.TopologyBuilderPage,
      ),
  }),
);

export const GesBuilderPage = topologyViewerPlugin.provide(
  createRoutableExtension({
    name: 'GesBuilderPage',
    mountPoint: gesBuilderRouteRef,
    component: () =>
      import('./components/GesBuilderPage').then(m => m.GesBuilderPage),
  }),
);
